import type { Filters, OverrideValues } from '@/interfaces';

export const browserUrlKeys: OverrideValues<Partial<Filters>, string> = {
    sort: 'sorter',
    page: 'side',
    origin: 'fra',
    destinations: 'til',
    meals: 'kost',
    facilities: 'fasiliteter',
    activities: 'aktiviteter',
    priceRange: 'pris',
    keywords: 'stikkord',
    suppliers: 'med',
    distanceToBeach: 'strand',
    distanceToCity: 'sentrum',
    rating: 'hotellstandard',
    travelMonths: 'reiseperiode',
    departureDate: 'avreise',
    returnDate: 'hjemreise',
    duration: 'reiselengde',
    hotelId: 'hotellId',
    numberOfAdults: 'voksne',
    agesOfChildren: 'alderBarn',
    boundingBox: 'bbox',
    destinationLabel: 'sted',
};

export const apiUrlKeys: OverrideValues<Partial<Filters>, string> = {
    sort: 'sort',
    page: 'page',
    origin: 'from',
    destinations: 'to',
    meals: 'meals',
    facilities: 'facilities',
    activities: 'activities',
    priceRange: 'price',
    keywords: 'q',
    suppliers: 'suppliers',
    distanceToBeach: 'beach',
    distanceToCity: 'city',
    rating: 'rating',
    travelMonths: 'travelMonths',
    departureDate: 'departureDate',
    returnDate: 'returnDate',
    duration: 'duration',
    hotelId: 'hotelId',
    numberOfAdults: 'numberOfAdults',
    agesOfChildren: 'agesOfChildren',
    boundingBox: 'bbox',
};
